export default function (totalCharge, quantity, transactionId) {
  fbq("track", "Purchase", {
    value: totalCharge,
    currency: "USD",
    content_ids: [transactionId],
    content_type: "product",
  }, {
    eventID: transactionId,
  });
}
